import { propOr, identity } from 'ramda';

const init = (handlers, initialState) => (state = initialState, action) => (
  propOr(identity, action.type, handlers)(state, action.payload)
);

export default init;
